<template>
  <h2 class="pb-2 border-bottom">Types of Hormone Replacement Therapy (HRT) We Can Offer</h2>
  <h5>For Women</h5>
  <ul>
    <li>Estrogen & Progesterone Therapy – Treats menopause symptoms (hot flashes, mood swings, osteoporosis prevention)</li>
    <li>Bioidentical Hormone Therapy (BHRT) – Natural plant-based hormones for customized treatment</li>
    <li>Testosterone Therapy for Women – Boosts libido, energy, and muscle tone</li>
    <li>Thyroid Hormone Therapy – Treats hypothyroidism and metabolic issues</li>
  </ul>

  <h5>For Men</h5>
  <ul>
    <li>Testosterone Replacement Therapy (TRT) – Injections, creams, or pellets for low testosterone</li>
    <li>DHEA Therapy – Supports adrenal function, muscle growth, and mood balance</li>
    <li>Thyroid Optimization – Addresses fatigue, weight gain, and low metabolism</li>
  </ul>

  <h5>For Both Men & Women</h5>
  <ul>
    <li>Peptide Therapy – Growth hormone peptides (e.g., Sermorelin, Ipamorelin) for anti-aging, muscle recovery, and fat loss</li>
    <li>Adrenal & Cortisol Support – Helps with chronic stress, fatigue, and hormonal imbalances</li>
  </ul>

  <h2 class="pb-2 border-bottom">Treatment Options & Delivery Methods</h2>
  <ul>
    <li>Injections – Weekly or biweekly testosterone, estrogen, or peptide injections</li>
    <li>Pellet Therapy – Long-lasting hormone pellets inserted under the skin (3-6 months)</li>
    <li>Topical Creams/Gels – Absorbed through the skin, convenient for daily use</li>
    <li>Oral Medications – Available for some hormone types but less common due to liver metabolism</li>
  </ul>

  <h2 class="pb-2 border-bottom">Diagnostic & Monitoring Process</h2>
  <p>To ensure safe and personalized treatment, offer:</p>
  <ul>
    <li>Comprehensive blood panels (hormone levels, thyroid, metabolic markers)</li>
    <li>Initial consultation & treatment planning</li>
    <li>Ongoing lab testing & dose adjustments</li>
    <li>Telemedicine follow-ups for monitoring</li>
  </ul>
</template>

<script>
export default {
  name: 'HormoneReplacementContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
